export const DEFAULT_MARGIN = { mobile: 2, desktop: 5 };
